(function ($) {
  'use strict';

  const SLIDER_SELECTOR = '.js-bold-benefit-blocks-slider';
  const MOBILE_BREAKPOINT = 990;
  const DESKTOP_WIDE_BREAKPOINT = 1480;
  const MOBILE_SIDE_PEEK_DEFAULT = 90;
  const MOBILE_GAP = 30;
  const MOBILE_FIRST_SLIDE_OFFSET = 30;

  const getSectionStyles = ($slider) => {
    const section = $slider.closest('.bold-benefit-blocks')[0];
    return section ? getComputedStyle(section) : null;
  };

  const readCssPx = (styles, property, fallback) => {
    if (!styles) return fallback;

    const value = styles.getPropertyValue(property).trim();
    if (!value) return fallback;

    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  };

  const getMobileSidePeek = ($slider) => {
    return readCssPx(getSectionStyles($slider), '--bbb-slide-peek-mobile-side', MOBILE_SIDE_PEEK_DEFAULT);
  };

  const applyInitialMobileTrackOffset = ($slider) => {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    if ($slider.data('bbbInitialOffsetReleased')) return;

    const track = $slider.find('.slick-track')[0];
    if (!track) return;

    track.style.setProperty('transform', `translate3d(${MOBILE_FIRST_SLIDE_OFFSET}px, 0px, 0px)`, 'important');
    $slider.data('bbbInitialOffsetApplied', true);
  };

  const releaseInitialMobileTrackOffset = ($slider) => {
    if ($slider.data('bbbInitialOffsetReleased')) return;

    const track = $slider.find('.slick-track')[0];
    if (track && track.style.getPropertyPriority('transform') === 'important') {
      track.style.removeProperty('transform');
    }

    $slider.data('bbbInitialOffsetReleased', true);
    $slider.removeData('bbbInitialOffsetApplied');
  };

  const destroyBoldBenefitBlocksSlider = ($slider) => {
    if (!$slider || $slider.length === 0) return;

    $slider.off('.boldBenefitBlocks');
    $slider.removeData('bbbInitialOffsetApplied');
    $slider.removeData('bbbInitialOffsetReleased');
    $slider.find('.slick-slide').css('width', '');

    if ($slider.hasClass('slick-initialized')) {
      try {
        $slider.slick('unslick');
      } catch (error) {
        // no-op
      }
    }
  };

  const setMobileSlideWidths = ($slider) => {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;

    const listWidth = $slider.find('.slick-list').width();
    if (!listWidth) return;

    const sidePeek = getMobileSidePeek($slider);
    const slideWidth = Math.max(listWidth - sidePeek - MOBILE_GAP, 220);
    $slider.find('.slick-slide').css('width', `${slideWidth}px`);
  };

  const clearInlineSlideWidths = ($slider) => {
    $slider.find('.slick-slide').css('width', '');
  };

  const initBoldBenefitBlocksSlider = ($slider) => {
    if (!$slider || $slider.length === 0) return;

    destroyBoldBenefitBlocksSlider($slider);

    $slider.on('init.boldBenefitBlocks setPosition.boldBenefitBlocks breakpoint.boldBenefitBlocks', function () {
      const $el = $(this);

      if (window.innerWidth < MOBILE_BREAKPOINT) {
        setMobileSlideWidths($el);
      }

      // Keep the initial offset until the user leaves slide 1 for the first time
      if (!$el.data('bbbInitialOffsetReleased')) {
        window.requestAnimationFrame(function () {
          applyInitialMobileTrackOffset($el);
        });
      }
    });

    // After the user moves away from the first slide, hand control back to Slick permanently
    $slider.on('afterChange.boldBenefitBlocks', function (event, slick, currentSlide) {
      if (currentSlide !== 0) {
        releaseInitialMobileTrackOffset($(this));
      }
    });

    $slider.slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: DESKTOP_WIDE_BREAKPOINT,
          settings: {
            infinite: false,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: false
          }
        },
        {
          breakpoint: MOBILE_BREAKPOINT,
          settings: {
            infinite: false,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            centerMode: true,
            centerPadding: '0px'
          }
        }
      ]
    });
  };

  const initAllBoldBenefitBlocksSliders = ($context) => {
    $(SLIDER_SELECTOR, $context || document).each(function () {
      initBoldBenefitBlocksSlider($(this));
    });
  };

  let resizeTimeout;

  $(window).on('resize.boldBenefitBlocks', function () {
    window.clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(function () {
      $(SLIDER_SELECTOR).each(function () {
        const $slider = $(this);

        if ($slider.hasClass('slick-initialized')) {
          if (window.innerWidth < MOBILE_BREAKPOINT) {
            setMobileSlideWidths($slider);
          } else {
            clearInlineSlideWidths($slider);
          }

          $slider.slick('setPosition');
        }
      });
    }, 150);
  });

  $(function () {
    initAllBoldBenefitBlocksSliders();
  });

  document.addEventListener('shopify:section:load', function (event) {
    window.setTimeout(function () {
      initAllBoldBenefitBlocksSliders(event.target);
    }, 100);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    $(SLIDER_SELECTOR, event.target).each(function () {
      destroyBoldBenefitBlocksSlider($(this));
    });
  });
})(jQuery);
